//! 開始做專案，這裡沒用到的圖、config沒用到的key，要刪掉！！！
import yidaLogo from '../assets/platformConfig/logo_yida_01.png'
import yidaMobile from '../assets/platformConfig/mb_bar_yida_01.png'

let platformConfig = {}
const beforeOnlineConfig = {
  title: 'beforeOnline'
}
const devConfig = {
  logo: yidaLogo,
  logoMobile: yidaMobile,
  appId: 'dev-id',
  locale: {
    cn: 'CN',
    tw: 'TW'
  },
  baseURL: 'https://eda-logistics.net/gateway',
  title: 'devTitle',
  baseSixFour: 'TUlHZk1BMEdDU3FHU0liM0RRRUJBUVVBQTRHTkFEQ0JpUUtCZ1FDL1ZuNHpmbm01VmxoOFBZOVJ4T1pFRG1HR21YOEZIL3JlK0U0WkVyMlFMZnMxcThtbzBFZUg2RlpWTnZRWXVHak54K1JrMHZLTEUrZTc1QjBIV2VEa1RBSFgvMWJYN21OZWlvblJLSjMydi83RGN6Tk1oS3ZlYkU4NjcxYXhqRkVPalp2WEVxcmNDTFEzZEIreEt0R0lDYnJRRHovZDNnUFZKVVhCNHQ5YlZ3SURBUUFC'
}
const yidaConfig = {
  logo: yidaLogo,
  logoMobile: yidaMobile,
  appId: 'dev-id',
  locale: {
    cn: 'CN',
    tw: 'TW'
  },
  title: 'devTitle'
}
const wandaConfig = {
  // logo: yidaLogo,
  // logoMobile: yidaMobile,
  appId: 'dev-id',
  locale: {
    cn: 'CN',
    tw: 'TW',
    en: 'EN'
  },
  title: 'devTitle'
}
switch (process.env.VUE_APP_TITLE) {
  case 'beforeOnline':
    platformConfig = beforeOnlineConfig
    break
  case 'yida':
    platformConfig = yidaConfig
    break
  case 'wanda':
    platformConfig = wandaConfig
    break
  default:
    platformConfig = devConfig
}
export default platformConfig
